import {EditorStyling} from "./editor.styling";

export const defaultStyling: Required<EditorStyling> = {
    theme: "chrome",
    lineHeight: 2
}
